import { Flex, Stack, Icon, Heading, Text } from '@backyard-ui/core'
import { memo } from 'react'

import { ArrowBackRegular } from 'scripts/react-components/shared/icons'

type HeaderProps = {
  shopName: string
}

const Header = (props: Readonly<HeaderProps>) => {
  const { shopName } = props

  return (
    <Stack
      direction="column"
      spacing="1"
      className="h-12"
      data-testid="chat-header">
      <Flex align="center" justify="space-between">
        <Stack spacing="2" align="center">
          <a href="/meus-pedidos" className="flex">
            <Icon size="lg" data-testid="redirect-chat-icon">
              <ArrowBackRegular />
            </Icon>
          </a>

          <Heading size="md" color="gray-900">
            Conversa com vendedor
          </Heading>
        </Stack>
      </Flex>

      <Text size="md" color="gray-600">
        Vendido e entregue por <b>{shopName}</b>
      </Text>
    </Stack>
  )
}

Header.displayName = 'header'

export default memo(Header)
